const useFormatCurrency = () => {
  var currencyFormatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    // currencyDisplay: "code",
  });

  const formatCurrency = (number) => currencyFormatter.format(number);

  return { formatCurrency };
};

export { useFormatCurrency };
